import { inject } from "vue";
import ConfirmationService from "../Services/ConfirmationService";
export const ConfirmationServiceSymbol = Symbol();
export const ConfirmationServicePlugin = {
    install: (app) => {
        app.provide(ConfirmationServiceSymbol, new ConfirmationService());
    },
};
export function useConfirmationService() {
    const spinner = inject(ConfirmationServiceSymbol);
    if (!spinner) {
        throw new Error(`Could not resolve ${ConfirmationServiceSymbol.description}`);
    }
    return spinner;
}
